<template>
  <v-container class="container--fluid text-center">
    <v-card>
      <v-card-text>
      <!--  {{ this.datafromdb }}
        {{ this.series }}-->
        <div id="chart">
          <apexchart
            type="donut"
            width="100%"
            :options="chartOptions"
            :series="series"
          ></apexchart>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
//import { bus } from "../../../main";
import { defineComponent } from "@vue/composition-api";
import VueApexCharts from "vue-apexcharts";
import apifactory from "../api";

export default defineComponent({
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    ctrldata: [],
  },
  data: () => ({
    tempctrldata: [],
    datafromdb: [],
    testlabel: [],
    testseries: [],
    resultdata: [],

    series: [], // [44, 55, 41, 17, 15],
    chartOptions: {
      chart: {
        width: 380,
      },
      // labels: ['Apple', 'Mango', 'Orange', 'Watermelon'],
      legend: {
        position: "bottom",
        show: true,
        horizontalAlign: "left",
      },
      title: {
        text: "Sales Volume given by each variable",
        align: "center",
      },
      responsive: [
        {
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "bottom",
              show: false,
            },
          },
        },
      ],
    },
  }),

  methods: {
    getchartseries() {
      let tempdata1 = this.tempctrldata;
      this.datafromdb=[];
      let obj = new Object();
      for (var i = 0; i < tempdata1.length; i++) {
        if (tempdata1[i].region == "national") {
          obj[tempdata1[i].variable] = tempdata1[i].volume;
        }
      }
      this.datafromdb.push(obj);
      //this.datafromdb =tempdata1;
      this.testseries = [];
      this.testlabel = [];
      this.testseries = [...Object.values(this.datafromdb[0])];
      this.series = [...Object.values(this.datafromdb[0])];
      this.testlabel = [...Object.keys(this.datafromdb[0])];
      this.chartOptions = {
        labels: this.testlabel,
      };
    },
    getchartseriesOld() {
      apifactory
        .get_model_volume_pie()
        .then((res) => {
          // alert(res.id);

          if (res.status != 200) {
            //this.countryList = null;
            alert(res.message);
          } else {
            /*let data = [];
                        data = res.data;
                        this.resultdata = data;
                        for (var k1 in data[0]) {
                            this.testlabel.push(k1);
                        }
                        for (var k2 in data[0]) {
                            for (var i = 0; i < data.length; i++) {
                                this.testseries.push(data[i][k2]);
                            }

                        }*/
            this.datafromdb = res.data;
            this.testseries = [];
            this.testlabel = [];
            this.testseries = [...Object.values(res.data[0])];
            this.series = [...Object.values(res.data[0])];
            this.testlabel = [...Object.keys(res.data[0])];
            this.chartOptions = {
              labels: this.testlabel,
            };
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },

    refresh() {
      //alert('refreshpiechart');
      this.getchartseries();
    },
  },
  mounted() {
    this.tempctrldata = [];
    this.tempctrldata = this.ctrldata;
    this.getchartseries();
    //bus.$off("refreshpiechart");
    // alert('dd');
   // bus.$on("refreshpiechart", this.refresh);
  },
  watch: {
    ctrldata: function (val) {
      // alert('Onoad -' + val);
      if (val) {
        this.tempctrldata = this.ctrldata;
        this.getchartseries();
      }
    },
  },
});
</script>
